module.exports = __webpack_public_path__ + "img/pr-3.691ffef1.png";